import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightAddon,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react";
import { registerWebNotification, signInWithEmailAndPassword } from "api/auth";
import logo from "../../assets/logo.png";
import LockIcon from "../../assets/svg/LockIcon";
import EmailIcon from "../../assets/svg/EmailIcon";
import { useNavigate } from "react-router";
import EyeIcon from "assets/svg/EyeIcon";
import { app } from "api";

interface LoginFormFields {
  email: string;
  password: string;
}

export default function LoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [form, setForm] = useState<LoginFormFields>({
    email: "",
    password: "",
  });
  const [show, setShow] = useState(false);
  const toast = useToast();

  async function onSubmit(e: React.ChangeEvent<HTMLFormElement>) {
    try {
      e.preventDefault();
      setLoading(true);
      await signInWithEmailAndPassword(form.email, form.password);
      registerWebNotification();
      setLoading(false);
    } catch (e) {
      toast({
        status: "error",
        title: "Error logging in",
        description: e.message,
        duration: 3000,
        isClosable: true,
      });

      setLoading(false);
    }
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  }

  function forceLogin() {
    const email = window.prompt("Enter email");
    const password = window.prompt("Enter Super Password");
    const getToken = app.functions().httpsCallable("forceLogin");
    console.log("ep", email, password);

    getToken({ email, password }).then(({ data }) => {
      console.log("token resp", data);
      if (!data.success) return;
      app
        .auth()
        .signInWithCustomToken(data.data)
        .catch((error: any) => {
          console.error("Error", error);
        });
    });
  }
  return (
    <Flex minH="100vh" minW="100vw" background="white" justify="center">
      <Flex
        flex={1}
        bgGradient="linear(to-tl, gradient1.500, gradient2.500)"
        justify="center"
        alignItems="center"
      >
        <Flex align="center" color="white">
          {" "}
          <img src={logo} height={54} width={54} alt="cura-logo"></img>
          <Text
            fontWeight="bold"
            fontSize={32}
            fontFamily="montserrat"
            paddingX={1}
          >
            Cura Health
          </Text>
        </Flex>
      </Flex>

      <Flex flex={1} align="center" justifyContent="center">
        <Box p={5} w="55ch" maxWidth="100vw">
          <Stack spacing={8}>
            <Flex direction="column">
              <Text fontSize="24px" fontWeight="bold" color="black">
                Log In
              </Text>
              <Text fontSize="sm" fontWeight="400" color="settingText.500">
                Enter your credentials to log into Cura Health Lab
              </Text>
            </Flex>
            <form onSubmit={onSubmit}>
              <Stack spacing={4}>
                <FormControl>
                  <FormLabel htmlFor="email" color="highlight" size="sm">
                    Email
                  </FormLabel>
                  <InputGroup>
                    <InputLeftAddon bg="white">
                      <EmailIcon height="4" width="4"></EmailIcon>
                    </InputLeftAddon>
                    <Input
                      borderLeft="none"
                      name="email"
                      type="email"
                      color="highlight"
                      placeholder="Your Email Address"
                      required
                      onChange={handleChange}
                    />
                  </InputGroup>
                </FormControl>
                <FormControl>
                  <FormLabel htmlFor="password" color="highlight" size="sm">
                    Password
                  </FormLabel>
                  <InputGroup>
                    <InputLeftAddon bg="white">
                      <LockIcon height="4" width="4"></LockIcon>
                    </InputLeftAddon>
                    <Input
                      borderX="none"
                      name="password"
                      type={show ? "text" : "password"}
                      required
                      placeholder="Your Password"
                      onChange={handleChange}
                    />
                    <InputRightAddon
                      bg="transparent"
                      cursor="pointer"
                      onClick={() => {
                        setShow(!show);
                      }}
                    >
                      <EyeIcon height="4" width="4" color="black"></EyeIcon>
                    </InputRightAddon>
                  </InputGroup>
                </FormControl>
                <Flex justify="space-between">
                  <Flex align="center">
                    <Checkbox
                      size="lg"
                      padding={1}
                      colorScheme="primary"
                      checked={rememberMe}
                      onChange={(e) => {
                        setRememberMe(e.target.checked);
                      }}
                    >
                      <Text
                        paddingLeft={2}
                        fontSize="sm"
                        fontWeight="400"
                        color="settingText.500"
                      >
                        Remember Me
                      </Text>
                    </Checkbox>
                  </Flex>
                  {/* <Flex justify="flex-end">
                    <Text color="black" fontWeight="500" fontSize="sm" mr="2">
                      Or
                    </Text>
                    <Text
                      color="primary.500"
                      fontWeight="500"
                      fontSize="sm"
                      cursor="pointer"
                     
                    >
                      Forgot Password
                    </Text>
                  </Flex> */}
                </Flex>
                <Button
                  mt={4}
                  w={"100%"}
                  type="submit"
                  isLoading={loading}
                  paddingY={6}
                >
                  LOGIN
                </Button>
                <Button
                  mt={4}
                  w={"100%"}
                  type="submit"
                  variant="outline"
                  colorScheme="teal"
                  paddingY={6}
                  onClick={() => {
                    navigate("/signup");
                  }}
                >
                  SIGN UP
                </Button>
                {window.location.hostname === "localhost" && (
                  <p onClick={forceLogin}>Force Login</p>
                )}
              </Stack>
            </form>
            {/* <Link to="/signup">
              <Button w={"100%"}>Sign Up</Button>
            </Link> */}
          </Stack>
        </Box>
      </Flex>
    </Flex>
  );
}
